export class QueueProcess {
  constructor(
    public id: string|number,
    public number_processed: number,
    public progress?: number,
    public title?: string,
    public speed?: string|number,
  ) {}
}
